import { Loader2, Check } from 'lucide-react'
import clsx from 'clsx'

interface GenerationProgressProps {
  generationStep: number
  channelCount: number
}

export function GenerationProgress({ generationStep, channelCount }: GenerationProgressProps) {
  const steps = [
    { step: 1, label: '소스 분석', desc: '핵심 메시지, 키워드, 대상 독자 추출' },
    { step: 2, label: '가이드라인 검색', desc: '채널별 가이드라인 매칭' },
    { step: 3, label: '콘텐츠 생성', desc: `${channelCount}개 채널 콘텐츠 작성` },
  ]

  return (
    <div className="p-6 flex flex-col items-center justify-center flex-1">
      <Loader2 className="w-10 h-10 text-primary animate-spin mb-4" />
      <h2 className="text-lg font-semibold mb-4">콘텐츠 생성 중...</h2>
      <div className="w-full max-w-md space-y-2">
        {steps.map((s) => (
          <div key={s.step} className={clsx(
            'flex items-center gap-3 p-3 rounded-lg transition-all',
            generationStep >= s.step ? 'bg-primary/10' : 'bg-bg-secondary'
          )}>
            <div className={clsx(
              'w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0',
              generationStep > s.step ? 'bg-green-500 text-white' :
              generationStep === s.step ? 'bg-primary text-white' :
              'bg-bg-elevated text-text-tertiary'
            )}>
              {generationStep > s.step ? <Check className="w-3 h-3" /> : s.step}
            </div>
            <div className="flex-1">
              <p className={clsx('text-sm font-medium', generationStep >= s.step ? 'text-text-primary' : 'text-text-tertiary')}>{s.label}</p>
              <p className="text-xs text-text-tertiary">{s.desc}</p>
            </div>
            {generationStep === s.step && <Loader2 className="w-3 h-3 text-primary animate-spin" />}
          </div>
        ))}
      </div>
    </div>
  )
}
